import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import useFetchData from "../../../controllers/useFetchData";

const Dropdown = ({
  query,
  variables,
  label,
  placeholder,
  dataKey,
  onChange,
  field,
  disabled,
  // value,
  isMulti = false,
  required = false,
  isClearable = false
}) => {
  const { data, error } = useFetchData(query, variables);
  if (error) return <div>Error loading {label}</div>;

  let options = [];

  if (dataKey === "listCategories" && Array.isArray(data?.[dataKey])) {
    options = data[dataKey]
      .filter((item) => item.parent_id === null)
      .map((item) => ({
        value: item.id,
        label: item.name,
      }));
  } else if (dataKey === "listUserByRole" && Array.isArray(data?.[dataKey])) {
    options = data[dataKey].map((item) => ({
      value: item.id,
      label: item.full_name,
    }));
  } else if (dataKey === "listCustomer" && Array.isArray(data?.[dataKey])) {
    options = data[dataKey].map((item) => ({
      value: item.id,
      label: item.full_name,
    }));
  } else if (dataKey === "listProduct" && Array.isArray(data?.[dataKey])) {
    options = data[dataKey].map((item) => ({
      value: item.id,
      label: item.name,
      price: item?.last_price || item.price,
      images: item?.images?.[0],
    }));
  } else if (Array.isArray(data?.[dataKey])) {
    options = data[dataKey].map((item) => ({
      value: item.id,
      label: item.name,
    }));
  } else if (data?.[dataKey]) {
    options = [data[dataKey]].map((item) => ({
      value: item?.id,
      label: item?.name,
    }));
  }

  // const getValue = () => {
  //   if (!value || value === 0 || value === "0" || value === "") {
  //     return null;
  //   }
  //   if (!field) {
  //     console.log("inside", options, value);
  //     return isMulti
  //       ? options.filter((option) => value?.includes(option.value))
  //       : options.find((option) => option?.value === value);
  //   } else {
  //     console.log("outside");
  //     return isMulti
  //       ? options.filter((option) => field.value?.includes(option.value))
  //       : options.find((option) => option?.value === field.value);
  //   }
  // };

  const dummyOption = [{ value: null, label: "No Value" }]

  return (
    <div className="mb-2">
      {
        label &&
        <label className="form-label">
          {label}
          {required && <span className="text-danger"> *</span>}
        </label>
      }
      <Select
        {...field}
        options={options?.length > 0 ? options : dummyOption}
        isDisabled={disabled}
        classNamePrefix="react-select"
        placeholder={placeholder}
        isMulti={isMulti}
        // value={
        //   isMulti
        //     ? options.filter((option) => field.value?.includes(option.value))
        //     : options.find((option) => option?.value === field.value)
        // }
        required={required && required}
        // value={null}
        isClearable={isClearable}
        value={
          (isMulti
            ? options?.filter((option) => field?.value?.includes(option.value))
            : options?.find((option) => option?.value === field?.value)) || null
        }
        onChange={(selectedOption) => {
          if (isMulti) {
            const selectedValues =
              selectedOption?.map((opt) => opt.value) || [];
            if (field?.onChange) {
              field.onChange(selectedValues);
            }
            onChange && onChange(selectedOption);
          } else if (dataKey == "listCategories") {
            onChange && onChange(data, selectedOption);
          } else {
            if (field?.onChange) {
              field.onChange(selectedOption?.value);
            }
            onChange && onChange(selectedOption);
          }
        }}
      />
    </div>
  );
};

Dropdown.propTypes = {
  query: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  variables: PropTypes.object,
  label: PropTypes.number.isRequired,
  field: PropTypes.object.isRequired,
  dataKey: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  isMulti: PropTypes.bool,
  required: PropTypes.bool,
  isClearable: PropTypes.bool,
};

export default Dropdown;
